(() => {
  'use strict';
  if(customElements.get('mb-product-form')) return;
  class MBProductForm extends HTMLElement {
    connectedCallback(){
      this.form=this.querySelector('form[action*="/cart/add"]');
      if(!this.form)return;
      this.submit=this.form.querySelector('[type="submit"]');
      this.error=this.querySelector('[data-product-form-error]');
      this.form.addEventListener('submit',e=>this.onSubmit(e));
    }
    async onSubmit(event){
      if(this.dataset.ajax==='false')return;
      event.preventDefault();
      if(this.submit?.classList.contains('is-loading'))return;
      this.setLoading(true); this.showError('');
      try{
        const idInput=this.form.querySelector('input[name="id"]');
        if(!idInput?.value)throw new Error('Please reload this product page and try again.');
        const body=new FormData(this.form);
        const res=await fetch(window.routes?.cart_add_url || window.AECBookstore?.routes?.cartAdd || '/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body});
        const data=await res.json();
        if(!res.ok || data.status){throw new Error(data.description||data.message||'Unable to add item');}
        document.dispatchEvent(new CustomEvent('aecbookstore:cart:refresh',{detail:{open:true,item:data}}));
        document.dispatchEvent(new CustomEvent('cart:add',{detail:{item:data,source:this}}));
      }catch(err){this.showError(err.message||'Unable to add this book to your cart.');}
      finally{this.setLoading(false);}
    }
    setLoading(on){if(!this.submit)return;this.submit.disabled=on;this.submit.classList.toggle('is-loading',on);this.submit.setAttribute('aria-busy',String(on));}
    showError(message){if(!this.error)return;this.error.textContent=message;this.error.hidden=!message;}
  }
  customElements.define('mb-product-form',MBProductForm);
})();
